import { Flex, Text, Toggle } from "src/elements";
import { OTouchedTitle } from "./OTouched";

interface Props {
  title: string;
  description?: string;
  value: boolean;
  setValue: (value: boolean) => void;
  isDisabled?: boolean;

  path?: string;
  testId?: string;
}

export const RuleToggle = ({
  title,
  description,
  value,
  setValue,
  isDisabled,
  path,
  testId,
}: Props) => {
  return (
    <Flex column justify="center" padding="10px" gap="10px" data-testid={testId}>
      <OTouchedTitle path={path}>
        <Text variant="small1" textAlign="center" isDisabled={isDisabled}>
          {title}
        </Text>
      </OTouchedTitle>

      {description && (
        <Text variant="small2" textAlign="center" isDisabled={isDisabled}>
          {description}
        </Text>
      )}

      <Toggle
        value={value}
        setValue={setValue}
        isDisabled={isDisabled}
        offLabel="No"
        onLabel="Yes"
      />
    </Flex>
  );
};
